// src/pages/produccion/Merma.jsx
// Fusiona Captura de Merma + Historial de Merma en una sola pantalla
// con pestañas — más profesional y familiar para el equipo (mismo
// patrón que ya usan en Excel con las pestañas de hojas).

import { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import api from '../../services/api';

const RECETAS = [
  { receta: 'Granola Original', linea: 'Granola' },
  { receta: 'Granola Ligera', linea: 'Granola' },
  { receta: 'Granola Chocolate', linea: 'Granola' },
  { receta: 'Granola Vainilla', linea: 'Granola' },
  { receta: 'Granola Maple', linea: 'Granola' },
  { receta: 'Cereal Arándano', linea: 'Granola' },
  { receta: 'Cereal Quinoa', linea: 'Granola' },
  { receta: 'Cereal Chocolate', linea: 'Granola' },
  { receta: 'Cereal Maple', linea: 'Granola' },
  { receta: 'Barra Original', linea: 'Barras' },
  { receta: 'Barra Ligera', linea: 'Barras' },
  { receta: 'Barra Chocolate', linea: 'Barras' },
];
const TURNOS = ['Matutino', 'Nocturno'];
const MESES = [
  ['01', 'Enero'], ['02', 'Febrero'], ['03', 'Marzo'], ['04', 'Abril'], ['05', 'Mayo'], ['06', 'Junio'],
  ['07', 'Julio'], ['08', 'Agosto'], ['09', 'Septiembre'], ['10', 'Octubre'], ['11', 'Noviembre'], ['12', 'Diciembre'],
];

function ultimoDiaDelMes(anio, mes) {
  return new Date(anio, parseInt(mes), 0).getDate();
}

export default function Merma() {
  const [tab, setTab] = useState('captura');

  return (
    <div style={styles.contenedor} className="contenedor-captura">
      <h1 style={styles.titulo}>Merma (F-PRO-38)</h1>
      <div style={styles.tabBar}>
        <button onClick={() => setTab('captura')} style={{ ...styles.tabBtn, ...(tab === 'captura' ? styles.tabBtnActivo : {}) }}>
          📝 Captura
        </button>
        <button onClick={() => setTab('historial')} style={{ ...styles.tabBtn, ...(tab === 'historial' ? styles.tabBtnActivo : {}) }}>
          📋 Historial
        </button>
      </div>
      {tab === 'captura' ? <TabCaptura /> : <TabHistorial />}
    </div>
  );
}

function TabCaptura() {
  const [loteBuscado, setLoteBuscado] = useState('');
  const [buscando, setBuscando] = useState(false);
  const [registro, setRegistro] = useState(null);
  const [esNuevo, setEsNuevo] = useState(false);
  const [mensaje, setMensaje] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [pendientes, setPendientes] = useState([]);

  const [form, setForm] = useState({
    fecha: new Date().toISOString().slice(0, 10),
    turno: 'Matutino',
    receta: RECETAS[0].receta,
    merma_mezclado_kg: '',
    mezclado_observaciones: '',
    merma_horneado_formado_kg: '',
    horneado_formado_observaciones: '',
    merma_empaque_kg: '',
    empaque_observaciones: '',
  });

  async function cargarPendientes() {
    try {
      const res = await api.get('/api/produccion/merma/pendientes');
      setPendientes(res.data.data);
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => { cargarPendientes(); }, []);

  async function handleBuscarLote() {
    if (!loteBuscado.trim()) return;
    try {
      setBuscando(true);
      setMensaje(null);
      const res = await api.get(`/api/produccion/merma/lote/${encodeURIComponent(loteBuscado.trim())}`);
      if (res.data.data) {
        setRegistro(res.data.data);
        setEsNuevo(false);
        setForm((prev) => ({
          ...prev,
          fecha: res.data.data.fecha.slice(0, 10),
          turno: res.data.data.turno,
          receta: res.data.data.receta,
          merma_mezclado_kg: '',
          mezclado_observaciones: '',
          merma_horneado_formado_kg: '',
          horneado_formado_observaciones: '',
          merma_empaque_kg: '',
          empaque_observaciones: '',
        }));
      } else {
        setRegistro(null);
        setEsNuevo(true);
      }
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: 'No se pudo buscar el lote.' });
    } finally {
      setBuscando(false);
    }
  }

  function handleChange(campo, valor) {
    setForm((prev) => ({ ...prev, [campo]: valor }));
  }

  async function handleGuardar() {
    try {
      setGuardando(true);
      setMensaje(null);
      const payload = { ...form, lote_mezcla: loteBuscado.trim() };
      await api.post('/api/produccion/merma', payload);
      setMensaje({ tipo: 'ok', texto: '✓ Guardado correctamente.' });
      cargarPendientes();
      handleNuevoLote();
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: err.response?.data?.error || 'No se pudo guardar.' });
    } finally {
      setGuardando(false);
    }
  }

  function handleNuevoLote() {
    setLoteBuscado('');
    setRegistro(null);
    setEsNuevo(false);
    setForm({
      fecha: new Date().toISOString().slice(0, 10),
      turno: 'Matutino',
      receta: RECETAS[0].receta,
      merma_mezclado_kg: '',
      mezclado_observaciones: '',
      merma_horneado_formado_kg: '',
      horneado_formado_observaciones: '',
      merma_empaque_kg: '',
      empaque_observaciones: '',
    });
  }

  const recetaSel = RECETAS.find((r) => r.receta === form.receta);
  const esBarras = recetaSel?.linea === 'Barras';
  const labelEtapa2 = esBarras ? 'Formado (kg)' : 'Horneado (kg)';

  const mezcladoListo = registro?.merma_mezclado_kg !== null && registro?.merma_mezclado_kg !== undefined;
  const formadoListo = registro?.merma_horneado_formado_kg !== null && registro?.merma_horneado_formado_kg !== undefined;
  const empaqueListo = registro?.merma_empaque_kg !== null && registro?.merma_empaque_kg !== undefined;

  const mostrarFormulario = esNuevo || registro;

  const totalMerma =
    (mezcladoListo ? parseFloat(registro.merma_mezclado_kg) : parseFloat(form.merma_mezclado_kg) || 0) +
    (formadoListo ? parseFloat(registro.merma_horneado_formado_kg) : parseFloat(form.merma_horneado_formado_kg) || 0) +
    (empaqueListo ? parseFloat(registro.merma_empaque_kg) : parseFloat(form.merma_empaque_kg) || 0);

 return (
  <div className="dosColumnas">
      <div>
        <div style={styles.tarjeta}>
          <label style={styles.label}>Lote de Mezcla</label>
          <div style={{ display: 'flex', gap: '8px' }}>
            <input
              type="text"
              value={loteBuscado}
              onChange={(e) => setLoteBuscado(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleBuscarLote()}
              placeholder="Ej. D-MZ0120826"
              style={{ ...styles.input, flex: 1 }}
            />
            <button onClick={handleBuscarLote} disabled={buscando} style={styles.botonBuscar}>
              {buscando ? 'Buscando...' : 'Buscar'}
            </button>
          </div>
          {registro && (
            <div style={styles.avisoExistente}>
              Lote existente: {registro.receta} · {new Date(registro.fecha).toLocaleDateString('es-MX')} · {registro.turno}
              <button onClick={handleNuevoLote} style={styles.linkChico}>Buscar otro lote</button>
            </div>
          )}
          {esNuevo && (
            <div style={styles.avisoNuevo}>
              Este lote no existe todavía — lo vas a crear.
              <button onClick={handleNuevoLote} style={styles.linkChico}>Cancelar</button>
            </div>
          )}
        </div>

        {mostrarFormulario && (
          <div style={{ ...styles.tarjeta, marginTop: '14px' }}>
           <div className="fila2">
            <Campo label="Fecha">
                <input type="date" value={form.fecha} onChange={(e) => handleChange('fecha', e.target.value)} disabled={!esNuevo} style={styles.input} />
              </Campo>
              <Campo label="Turno">
                <select value={form.turno} onChange={(e) => handleChange('turno', e.target.value)} disabled={!esNuevo} style={styles.input}>
                  {TURNOS.map((t) => <option key={t} value={t}>{t}</option>)}
                </select>
              </Campo>
            </div>
            <Campo label="Receta">
              <select value={form.receta} onChange={(e) => handleChange('receta', e.target.value)} disabled={!esNuevo} style={styles.input}>
                {RECETAS.map((r) => <option key={r.receta} value={r.receta}>{r.receta}</option>)}
              </select>
            </Campo>
            <div className="fila3">
              <CampoEtapa
                label="Mezclado (kg)" listo={mezcladoListo}
                valorListo={registro?.merma_mezclado_kg} obsListo={registro?.mezclado_observaciones}
                value={form.merma_mezclado_kg} onChange={(v) => handleChange('merma_mezclado_kg', v)}
                obsValue={form.mezclado_observaciones} onObsChange={(v) => handleChange('mezclado_observaciones', v)}
              />
              <CampoEtapa
                label={labelEtapa2} listo={formadoListo}
                valorListo={registro?.merma_horneado_formado_kg} obsListo={registro?.horneado_formado_observaciones}
                value={form.merma_horneado_formado_kg} onChange={(v) => handleChange('merma_horneado_formado_kg', v)}
                obsValue={form.horneado_formado_observaciones} onObsChange={(v) => handleChange('horneado_formado_observaciones', v)}
              />
              <CampoEtapa
                label="Empaque (kg)" listo={empaqueListo}
                valorListo={registro?.merma_empaque_kg} obsListo={registro?.empaque_observaciones}
                value={form.merma_empaque_kg} onChange={(v) => handleChange('merma_empaque_kg', v)}
                obsValue={form.empaque_observaciones} onObsChange={(v) => handleChange('empaque_observaciones', v)}
              />
            </div>
            <div style={styles.totalBox}>Merma total (parcial): <strong>{totalMerma.toFixed(2)} kg</strong></div>
            {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}
            <button onClick={handleGuardar} disabled={guardando} style={styles.botonGuardar}>
              {guardando ? 'Guardando...' : 'Guardar mi parte'}
            </button>
          </div>
        )}
      </div>

      <div>
        <h2 style={styles.subtituloLista}>Lotes con etapas pendientes (últimos 14 días)</h2>
        <div style={styles.listaPendientes}>
          {pendientes.length === 0 && <p style={{ color: '#8A7690', fontSize: '12px' }}>No hay lotes pendientes 🎉</p>}
          {pendientes.map((p) => (
            <div key={p.lote_mezcla} style={styles.filaPendiente}>
              <span style={styles.lotePendiente}>{p.lote_mezcla}</span>
              <span style={styles.recetaPendiente}>{p.receta}</span>
              <Badge listo={p.mezclado_listo} label="Mezclado" />
              <Badge listo={p.formado_listo} label={p.linea === 'Barras' ? 'Formado' : 'Horneado'} />
              <Badge listo={p.empaque_listo} label="Empaque" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function TabHistorial() {
  const [registros, setRegistros] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  const [fDesde, setFDesde] = useState('');
  const [fHasta, setFHasta] = useState('');
  const [fMes, setFMes] = useState('');
  const [fAnio, setFAnio] = useState(new Date().getFullYear());
  const [fTurno, setFTurno] = useState('');
  const [fReceta, setFReceta] = useState('');

  async function cargar() {
    try {
      setCargando(true);
      const params = {};
      if (fDesde) params.desde = fDesde;
      if (fHasta) params.hasta = fHasta;
      if (fTurno) params.turno = fTurno;
      if (fReceta) params.receta = fReceta;
      const res = await api.get('/api/produccion/merma', { params });
      setRegistros(res.data.data);
      setError(null);
    } catch (err) {
      console.error(err);
      setError('No se pudo cargar el historial.');
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleMesChange(mes) {
    setFMes(mes);
    if (mes) {
      setFDesde(`${fAnio}-${mes}-01`);
      setFHasta(`${fAnio}-${mes}-${String(ultimoDiaDelMes(fAnio, mes)).padStart(2, '0')}`);
    }
  }

  function limpiarFiltros() {
    setFDesde(''); setFHasta(''); setFMes(''); setFTurno(''); setFReceta('');
  }

  function total(r) {
    return (parseFloat(r.merma_mezclado_kg) || 0) + (parseFloat(r.merma_horneado_formado_kg) || 0) + (parseFloat(r.merma_empaque_kg) || 0);
  }

  function exportarExcel() {
    const filas = registros.map((r) => ({
      Lote: r.lote_mezcla,
      Fecha: new Date(r.fecha).toLocaleDateString('es-MX'),
      Turno: r.turno,
      Receta: r.receta,
      'Mezclado (kg)': r.merma_mezclado_kg ?? '',
      'Obs. Mezclado': r.mezclado_observaciones || '',
      'Horneado/Formado (kg)': r.merma_horneado_formado_kg ?? '',
      'Obs. Horneado/Formado': r.horneado_formado_observaciones || '',
      'Empaque (kg)': r.merma_empaque_kg ?? '',
      'Obs. Empaque': r.empaque_observaciones || '',
      'Total (kg)': total(r).toFixed(2),
    }));
    const ws = XLSX.utils.json_to_sheet(filas);
    ws['!cols'] = [{ wch: 16 }, { wch: 12 }, { wch: 10 }, { wch: 18 }, { wch: 14 }, { wch: 28 }, { wch: 18 }, { wch: 28 }, { wch: 12 }, { wch: 28 }, { wch: 10 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Merma');
    XLSX.writeFile(wb, `dasavena_merma_${new Date().toISOString().slice(0, 10)}.xlsx`);
  }

  return (
    <div>
      <div style={styles.headerFila}>
        <p style={styles.subtitulo}>Todos los registros capturados — no solo los pendientes.</p>
        <button onClick={exportarExcel} disabled={registros.length === 0} style={styles.botonExcel}>⬇ Descargar Excel</button>
      </div>

      <div style={styles.filtrosBar}>
        <FiltroFecha label="Desde" value={fDesde} onChange={(v) => { setFDesde(v); setFMes(''); }} />
        <FiltroFecha label="Hasta" value={fHasta} onChange={(v) => { setFHasta(v); setFMes(''); }} />
        <FiltroSel label="Mes" value={fMes} onChange={handleMesChange} options={[['', '—'], ...MESES]} />
        <div style={styles.filtroGrupo}>
          <label style={styles.filtroLabel}>Año</label>
          <input type="number" value={fAnio} onChange={(e) => setFAnio(e.target.value)} style={{ ...styles.filtroInput, width: '80px' }} />
        </div>
        <FiltroSel label="Turno" value={fTurno} onChange={setFTurno} options={[['', 'Todos'], ...TURNOS.map((t) => [t, t])]} />
        <FiltroSel label="Receta" value={fReceta} onChange={setFReceta} options={[['', 'Todas'], ...RECETAS.map((r) => [r.receta, r.receta])]} />
        <button onClick={cargar} style={styles.botonBuscar}>Buscar</button>
        <button onClick={limpiarFiltros} style={styles.botonLimpiar}>Limpiar</button>
      </div>

      <div style={styles.resultadoInfo}>{registros.length} registros</div>

      {cargando ? (
        <div>Cargando...</div>
      ) : error ? (
        <div style={{ color: '#B23A48' }}>{error}</div>
      ) : (
        <div style={styles.tablaScroll}>
          <table style={styles.tabla}>
            <thead>
              <tr>
                <th style={styles.th}>Lote</th><th style={styles.th}>Fecha</th><th style={styles.th}>Turno</th>
                <th style={styles.th}>Receta</th>
                <th style={styles.th}>Mezclado</th><th style={styles.th}>Obs. Mezclado</th>
                <th style={styles.th}>Horneado/Formado</th><th style={styles.th}>Obs. Horneado/Formado</th>
                <th style={styles.th}>Empaque</th><th style={styles.th}>Obs. Empaque</th>
                <th style={styles.th}>Total</th>
              </tr>
            </thead>
            <tbody>
              {registros.map((r) => (
                <tr key={r.id}>
                  <td style={styles.td}>{r.lote_mezcla}</td>
                  <td style={styles.td}>{new Date(r.fecha).toLocaleDateString('es-MX')}</td>
                  <td style={styles.td}>{r.turno}</td>
                  <td style={styles.td}>{r.receta}</td>
                  <td style={styles.td}>{r.merma_mezclado_kg ?? '—'}</td>
                  <td style={{ ...styles.td, maxWidth: 180, whiteSpace: 'normal', fontStyle: 'italic', color: '#8A7690' }}>{r.mezclado_observaciones || '—'}</td>
                  <td style={styles.td}>{r.merma_horneado_formado_kg ?? '—'}</td>
                  <td style={{ ...styles.td, maxWidth: 180, whiteSpace: 'normal', fontStyle: 'italic', color: '#8A7690' }}>{r.horneado_formado_observaciones || '—'}</td>
                  <td style={styles.td}>{r.merma_empaque_kg ?? '—'}</td>
                  <td style={{ ...styles.td, maxWidth: 180, whiteSpace: 'normal', fontStyle: 'italic', color: '#8A7690' }}>{r.empaque_observaciones || '—'}</td>
                  <td style={{ ...styles.td, fontWeight: 700 }}>{total(r).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {registros.length === 0 && <p style={{ padding: 16, color: '#8A7690', fontSize: 12 }}>Sin registros para este filtro.</p>}
        </div>
      )}
    </div>
  );
}

function Campo({ label, children }) {
  return <div style={{ marginBottom: '14px' }}><label style={styles.label}>{label}</label>{children}</div>;
}
function CampoEtapa({ label, listo, valorListo, obsListo, value, onChange, obsValue, onObsChange }) {
  if (listo) {
    return (
      <div style={{ marginBottom: '14px' }}>
        <label style={styles.label}>{label}</label>
        <div style={styles.campoListo}>✓ {valorListo} kg</div>
        <div style={styles.obsListoTexto}>{obsListo ? `"${obsListo}"` : 'sin observación'}</div>
      </div>
    );
  }
  return (
    <Campo label={label}>
      <input type="number" step="0.01" value={value} onChange={(e) => onChange(e.target.value)} style={styles.input} />
      <input
        type="text"
        value={obsValue}
        onChange={(e) => onObsChange(e.target.value)}
        placeholder="Observación de esta etapa..."
        style={{ ...styles.input, marginTop: '6px', fontSize: '11px' }}
      />
    </Campo>
  );
}
function Badge({ listo, label }) {
  return <span style={{ ...styles.badge, background: listo ? '#E8F1EC' : '#F9F0DD', color: listo ? '#3E7C5A' : '#C08A2B' }}>{listo ? '✓' : '⏳'} {label}</span>;
}
function FiltroSel({ label, value, onChange, options }) {
  return (
    <div style={styles.filtroGrupo}>
      <label style={styles.filtroLabel}>{label}</label>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={styles.filtroInput}>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
  );
}
function FiltroFecha({ label, value, onChange }) {
  return (
    <div style={styles.filtroGrupo}>
      <label style={styles.filtroLabel}>{label}</label>
      <input type="date" value={value} onChange={(e) => onChange(e.target.value)} style={styles.filtroInput} />
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '14px' },
  tabBar: { display: 'flex', gap: '6px', borderBottom: '2px solid #E6DDD2', marginBottom: '20px' },
  tabBtn: { padding: '10px 20px', fontSize: '13px', fontWeight: 600, color: '#8A7690', background: 'none', border: 'none', borderBottom: '3px solid transparent', cursor: 'pointer', marginBottom: '-2px' },
  tabBtnActivo: { color: '#4A1E5C', borderBottom: '3px solid #4A1E5C' },
  dosColumnas: { display: 'grid', gridTemplateColumns: '1.1fr 0.9fr', gap: '24px', alignItems: 'start' },
  headerFila: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', margin: 0 },
  botonExcel: { padding: '8px 16px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#3E7C5A', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  subtituloLista: { fontSize: '14px', color: '#2A1830', marginTop: '0', marginBottom: '10px' },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' },
  grid3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '14px' },
  label: { display: 'block', fontSize: '11px', color: '#8A7690', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '5px' },
  input: { width: '100%', padding: '8px 10px', fontSize: '13px', border: '1px solid #E6DDD2', borderRadius: '7px', fontFamily: 'Inter, sans-serif', boxSizing: 'border-box' },
  campoListo: { padding: '8px 10px', fontSize: '13px', background: '#E8F1EC', color: '#3E7C5A', borderRadius: '7px', fontWeight: 600 },
  totalBox: { margin: '4px 0 14px', background: '#F7EDD6', border: '1px solid #E6DDD2', borderRadius: '8px', padding: '9px 14px', fontSize: '13px', color: '#6E4F80' },
  obsListoTexto: { fontSize: '10px', color: '#8A7690', fontStyle: 'italic', marginTop: '3px' },
  botonBuscar: { padding: '8px 18px', fontSize: '13px', fontWeight: 600, color: '#fff', background: '#4A1E5C', border: 'none', borderRadius: '7px', cursor: 'pointer' },
  botonLimpiar: { padding: '7px 14px', fontSize: '12px', color: '#8A7690', background: 'transparent', border: '1px solid #E6DDD2', borderRadius: '6px', cursor: 'pointer' },
  avisoExistente: { marginTop: '10px', fontSize: '12px', color: '#6E4F80', display: 'flex', alignItems: 'center', gap: '10px' },
  avisoNuevo: { marginTop: '10px', fontSize: '12px', color: '#C08A2B', display: 'flex', alignItems: 'center', gap: '10px' },
  linkChico: { fontSize: '11px', color: '#8A7690', background: 'none', border: 'none', textDecoration: 'underline', cursor: 'pointer' },
  mensaje: { fontSize: '13px', marginTop: '10px', marginBottom: '4px', fontWeight: 600 },
  botonGuardar: { marginTop: '10px', width: '100%', padding: '12px', fontSize: '14px', fontWeight: 700, color: '#fff', background: '#4A1E5C', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  listaPendientes: { display: 'flex', flexDirection: 'column', gap: '8px' },
  filaPendiente: { display: 'flex', alignItems: 'center', gap: '12px', background: '#fff', border: '1px solid #E6DDD2', borderRadius: '8px', padding: '8px 12px', fontSize: '12px' },
  lotePendiente: { fontWeight: 700, color: '#2A1830', minWidth: '110px' },
  recetaPendiente: { color: '#8A7690', minWidth: '140px' },
  badge: { padding: '3px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: 600 },
  filtrosBar: { display: 'flex', alignItems: 'flex-end', gap: '12px', flexWrap: 'wrap', background: '#fff', border: '1px solid #E6DDD2', borderRadius: '10px', padding: '14px 16px', marginBottom: '10px' },
  filtroGrupo: { display: 'flex', flexDirection: 'column', gap: '4px' },
  filtroLabel: { fontSize: '10px', color: '#8A7690', textTransform: 'uppercase', letterSpacing: '0.4px' },
  filtroInput: { padding: '6px 8px', fontSize: '12px', border: '1px solid #E6DDD2', borderRadius: '6px', fontFamily: 'Inter, sans-serif' },
  resultadoInfo: { fontSize: '12px', color: '#8A7690', marginBottom: '10px' },
  tablaScroll: { overflowX: 'auto', background: '#fff', border: '1px solid #E6DDD2', borderRadius: '10px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '13px' },
  th: { textAlign: 'left', padding: '8px 10px', borderBottom: '2px solid #E6DDD2', color: '#6E4F80', fontWeight: 600, fontSize: '11px', textTransform: 'uppercase', whiteSpace: 'nowrap' },
  td: { padding: '6px 10px', borderBottom: '1px solid #F0E9E0', whiteSpace: 'nowrap' },
};